/**
 * Hit Record: a 3D, scored walk through Qwen3.8-27B as a DJ in a club, one prompt's run through its 64 layers. three.js is
 * big, so the player loads on its own, only on pages that show it, and never on the server.
 */
import dynamic from "next/dynamic";
import { useRouter } from "next/router";

const Player = dynamic(() => import("./Player"), {
  ssr: false,
  // The placeholder stands in while the player loads, and stays if it fails to: it says why in the console, as
  // next/dynamic hands it the error and logs nothing itself.
  loading: ({ error }) => {
    if (error) console.error(error);
    return (
      <div className="not-prose my-10 relative left-1/2 -translate-x-1/2 w-[min(calc(100vw-2rem),64rem)] aspect-video rounded-xl border border-[#2A2638] bg-[#06040C]" />
    );
  }
});

/** Avatar mode (`?avatar`): the DJ's head as a square still for Sam's socials, in place of the player. */
const Avatar = dynamic(() => import("./AvatarMode"), { ssr: false });

export default function HitRecord() {
  const { query } = useRouter();
  return query.avatar !== undefined ? <Avatar /> : <Player />;
}
